<h1>Badge Management</h1>

<div *ngIf="!badgeCode">
    The digital badge is a benefit of paying your annual fee. Your digital badge serves as a quick and reliable way to share and verify your credentials and can easily be added to your email signature, resume, or social media profile. To submit your annual payment and gain access to your digital badge, please click <a routerLink="/purchase/annual-renewal">here</a>.
</div>
<div *ngIf="badgeCode">
    <div>
        <p>Your digital badge serves as a quick and reliable way to share and verify your credentials. This badge can easily be added to your email signature, 
            resume, or social media profiles. Download your digital badge by clicking <a href="./assets/images/NBRC Digital Badge.jpg" download>here</a> or on 
            the image of your badge below. Once this is done, follow the step by step instructions provided to apply your badge.</p>
         <div style="display: flex;">
            <p><a href="./assets/images/NBRC Digital Badge.jpg" download><img  src="./assets/images/NBRC Digital Badge.jpg" alt="NBRC Digital Badge Icon" style="width:180px;"></a>
            <!-- <a download="./assets/images/NBRC Digital Badge.jpg" style="float: right; margin: .45em auto;"><button class="btn"><i class="fa fa-download">Download</i></button></a></p> -->
        </div>   
    </div>
    <br>
    <div>
        Your personalized digital badge URL: <a href="./badge/{{badgeCode}}" target="_blank">{{myLocation}}/badge/{{badgeCode}}</a>
    </div>
    <br>
    <button class="accordion">Share your Digital Badge Within an Email Signature</button>
    <div class="panel">
        <p>You can create a personalized signature for your email messages which includes your digital badge.  When the message recipient clicks to open the link within the icon in the signature, a new browser window will open, and your digital badge information appears. 
            To include your digital badge in an email signature, follow these step by step instructions or view our digital badge video here:</p>
        
        <strong>Create an email signature within Outlook </strong>
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>Copy the URL for your personalized digital badge.  </li>
            <li>Start a new email and click Signature from the toolbar, and then click on Signatures.  </li>
            <li>Either add a new signature or edit an existing signature.  </li>
            <li>Select the image icon and choose the image downloaded in Step 1.  </li>
            <li>Select the link icon and paste your personalized digital badge URL.  </li>
            <li>Click on OK to finish.</li>
        </ol>
        <strong>Create an email signature on other platforms </strong>
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>For your email service provider options page, click on the signature card and in addition to text, there should be an ability to add an image. Select your digital and upload the image.</li>
            <li>Once the badge image is inserted in the signature, right click on the image or click the web link icon to add your personalized URL.</li>
        </ol>
    </div>
    <button class="accordion">Share your Digital Badge Within a Resume</button>
        <div class="panel">
            <p>To add a certification/Badge to your resume or any other Word file, follow these step by step instructions:</p>
            <ol>
                <li>Download and save your Digital Badge image.</li>
                <li>Within the Word document, click the Insert tab, then Pictures, This Device and select the digital badge image you saved.</li>
                <li>Right click on the image within the document and select Link then add your personalized URL.</li>
            </ol>
        </div>
    <button class="accordion">Share your Digital Badge on LinkedIn</button>
    <div class="panel">
        <p>To add a certification/badge to your LinkedIn profile, follow these step by step instructions: 
        </p>
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>Log into LinkedIn and click the Me icon at the top of your LinkedIn homepage.</li>
            <li>Click View profile.</li>
            <li>If you have previously added a certification, scroll down to the Licenses and Certifications section, click Add and select Certifications.</li>
        </ol>
        <strong>Note that if you have never added a certification, you will first need to add a Licenses and Certifications section. On your profile page click Add profile section button, click the arrow icon next to Background and then click Licenses and Certifications.            
        </strong>
        <ol start="5">
            <li>Type in your certification information as shown in the figure below. You can obtain all the information that you need to input above.
        <img class="alignnone size-medium wp-image-8849" src="https://www.nbrc.org/wp-content/uploads/2020/07/Linked-In-License-Info.png" alt="Linked In license info image"  /></li>
            <li>Provide your Certification Name in the Name field. Add “National Board for Respiratory Care – NBRC” in the Issuing Organization field. Be sure to select the correct organization from the menu so the NBRC logo appears next to the certification on your profile. Note: The logo of the organization will appear on your profile, not the badge image. The Credential ID field should be left blank. Add your personalized URL link in the Credential URL field.  Be sure to select the correct authority from the menu so their logo appears next to the certification on your profile. Note: The logo of the organization will appear on your profile, not the badge image.</li>
            <li>Click Save.</li>
        </ol>
    </div>

    <button class="accordion">Share your Digital Badge on Facebook </button>
    <div class="panel">
        <p>You can share your digital badge on your Facebook page from the Timeline tab in 2 ways—either as a Life Event or as a Photo.</p>
        
        <strong>Post as a Life Event</strong>
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>Login to your Facebook account and from Timeline, click on Life Event.</li>
            <li>From Life Event, click on Work & Education and choose “Create Your Own…” tab at the bottom of the menu.</li>
            <li>Add a title on “Create Your Own…” page which indicates you earned a new credential.</li>
            <li>On the right side of the page, click on “Upload Photos” and choose the badge image that you saved in step 1.</li>
            <li>On the Story tab, add your personalized URL with the instructions to follow the link to view your credentials.</li>
            <li>Select the people you would like to share your accomplishment with and click save.</li>
            <li>Once saved, it will appear on your homepage.</li>
        </ol>
        <strong>Post as a Photo</strong>
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>Login to your Facebook account and from Timeline, click on Photo and then Upload Photo.</li>
            <li>Once you click on Upload Photo, select the digital badge image that you saved.</li>
            <li>When prompted to “write something about this photo,” add your personalized URL with the instructions to follow the link to view your credentials.</li>
            <li>Click Post and it will appear on your homepage.</li>
        </ol>
    </div>
    <button class="accordion">Share your Digital Badge on Twitter </button>
    <div class="panel">
        <p>Follow these step by step instructions to share your digital badge on Twitter:
        <ol>
            <li>Download and save your Digital Badge image.</li>
            <li>Log in to your Twitter account and click “Compose new Tweet” on the right-hand side of the menu</li>
            <li>Create a message that tells your followers about your new digital badge and credential(s) and inform your followers that they should “Follow this link to view my credential:…” and add your personalized URL link.</li>
            <li>Click Add photo and upload the digital badge image that you downloaded in step 1.</li>
            <li>Click the Tweet button and publish your credential to your followers.</li>
        </ol>
    </div>
    <br>
    <div>
        <p>For additional information about your digital badge and troubleshooting tips, visit our <a href="https://www.nbrc.org/digital-badge-faq/" target="_blank">[FAQ]</a>.</p>
    </div>
</div>